"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var index_1 = require("./index");
var keys = ['createNewText', 'addTaskButtonText', 'dragToCalendarText', 'dragInMailText', 'defaultTasksFolderName', 'selectTaskListAriaText', 'flaggedEmailsFolderName', 'manageAllTasks', 'showRecentlyCompleted', 'hideRecentlyCompleted', 'addAsTask', 'taskImportantAriaText', 'markAsCompleted', 'markAsNotCompleted', 'markAsImportant', 'removeImportance', 'removeReminder', 'setReminder', 'editReminder', 'removeDueDate', 'setDueDate', 'editDueDate', 'editTitle', 'deleteTask', 'viewEmail', 'viewEmailLinkInNote', 'moveInList', 'moveToTop', 'moveUp', 'moveDown', 'moveToBottom'];
exports.OwaTasksStringsStringModule = index_1.registerStringPackage('owa-tasks-strings', null, keys);
var exportedObject = {};
keys.forEach(function (key) {
    Object.defineProperty(exportedObject, key, { get: function () { return exports.OwaTasksStringsStringModule.strings.get(key); } });
});
/**
 * Selector to return the strings collection, so it can more easily be mocked.
 */
exports.getOwaTasksStrings = function () { return exportedObject; };
exports.default = exportedObject;
